import { api } from '../consumerApiSlice';
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        postConsumerApplicationsV1PrequalificationsApplicationIdNextLender: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/prequalifications/${queryArg.applicationId}/next_lender`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV1PrequalificationsApplicationIdNextLender,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        postConsumerApplicationsV1Prequalifications: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/prequalifications`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV1Prequalifications,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        getConsumerApplicationsV1PrequalificationsNew: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/prequalifications/new`,
                params: {
                    location_id: queryArg.locationId,
                    terms_language: queryArg.termsLanguage,
                },
            }),
        }),
        patchConsumerApplicationsV1CreditApplicationsApplicationId: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/credit_applications/${queryArg.applicationId}`,
                method: 'PATCH',
                body: queryArg.patchConsumerApplicationsV1CreditApplicationsApplicationId,
            }),
        }),
        postConsumerApplicationsV1CreditApplicationsApplicationIdPrequalify: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/credit_applications/${queryArg.applicationId}/prequalify`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV1CreditApplicationsApplicationIdPrequalify,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        getConsumerApplicationsV1CreditApplicationsApplicationIdPaymentCalculator: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/credit_applications/${queryArg.applicationId}/payment_calculator`,
                params: {
                    financed_amount: queryArg.financedAmount,
                    payment_frequency: queryArg.paymentFrequency,
                },
            }),
        }),
        postConsumerApplicationsV1CreditApplicationsApplyAfterPrequalification: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/credit_applications/apply_after_prequalification`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV1CreditApplicationsApplyAfterPrequalification,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        getConsumerApplicationsV1CreditApplicationsTokenToken: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/credit_applications/token/${queryArg.token}`,
                params: {
                    ssn_last_four: queryArg.ssnLastFour,
                    date_of_birth: queryArg.dateOfBirth,
                    zip: queryArg.zip,
                },
            }),
        }),
        getConsumerApplicationsV1CreditApplicationsTokenTokenValidate: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/credit_applications/token/${queryArg.token}/validate`,
            }),
        }),
        getConsumerApplicationsV1CreditApplicationsStatusStatus: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/credit_applications/status/${queryArg.status}`,
                params: {
                    ssn_last_four: queryArg.ssnLastFour,
                    date_of_birth: queryArg.dateOfBirth,
                    zip: queryArg.zip,
                    terms_language: queryArg.termsLanguage,
                    location_id: queryArg.locationId,
                },
            }),
        }),
        postConsumerApplicationsV1CreditApplicationsApplicationIdIdentityVerification: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/credit_applications/${queryArg.applicationId}/identity_verification`,
                method: 'POST',
            }),
        }),
        getConsumerApplicationsV1CreditApplicationsApplicationIdIdentityVerification: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/credit_applications/${queryArg.applicationId}/identity_verification`,
            }),
        }),
        postConsumerApplicationsV1CreditApplicationsApplicationIdApply: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/credit_applications/${queryArg.applicationId}/apply`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV1CreditApplicationsApplicationIdApply,
            }),
        }),
        getConsumerApplicationsV1LocationsSearch: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/locations/search`,
                params: {
                    ads_store_number: queryArg.adsStoreNumber,
                    location_id: queryArg.locationId,
                },
            }),
        }),
        getConsumerApplicationsV1LocationsSearchFull: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/locations/search_full`,
                params: {
                    search_criteria: queryArg.searchCriteria,
                    fields_to_search: queryArg.fieldsToSearch,
                    limit: queryArg.limit,
                },
            }),
        }),
        getConsumerApplicationsV1LocationsLocationIdLenderTermsLenderName: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/locations/${queryArg.locationId}/lender_terms/${queryArg.lenderName}`,
            }),
        }),
        getConsumerApplicationsV1BankNameLookup: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/bank_name_lookup`,
                params: {
                    routing_number: queryArg.routingNumber,
                },
            }),
        }),
        postConsumerApplicationsV1LinkGenerate: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/link/generate`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV1LinkGenerate,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        postConsumerApplicationsV1LinkFetch: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/link/fetch`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV1LinkFetch,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        postConsumerApplicationsV1LinkOtlGenerate: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/link/otl/generate`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV1LinkOtlGenerate,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        getConsumerApplicationsV1LinkOtlTokenValidate: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v1/link/otl/${queryArg.token}/validate`,
                headers: {
                    Authorization: queryArg.authorization,
                },
                params: {
                    store_link_campaign: queryArg.storeLinkCampaign,
                    store_id: queryArg.storeId,
                    location_id: queryArg.locationId,
                },
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as consumerApplicationsApi };
export const { usePostConsumerApplicationsV1PrequalificationsApplicationIdNextLenderMutation, usePostConsumerApplicationsV1PrequalificationsMutation, useGetConsumerApplicationsV1PrequalificationsNewQuery, useLazyGetConsumerApplicationsV1PrequalificationsNewQuery, usePatchConsumerApplicationsV1CreditApplicationsApplicationIdMutation, usePostConsumerApplicationsV1CreditApplicationsApplicationIdPrequalifyMutation, useGetConsumerApplicationsV1CreditApplicationsApplicationIdPaymentCalculatorQuery, useLazyGetConsumerApplicationsV1CreditApplicationsApplicationIdPaymentCalculatorQuery, usePostConsumerApplicationsV1CreditApplicationsApplyAfterPrequalificationMutation, useGetConsumerApplicationsV1CreditApplicationsTokenTokenQuery, useLazyGetConsumerApplicationsV1CreditApplicationsTokenTokenQuery, useGetConsumerApplicationsV1CreditApplicationsTokenTokenValidateQuery, useLazyGetConsumerApplicationsV1CreditApplicationsTokenTokenValidateQuery, useGetConsumerApplicationsV1CreditApplicationsStatusStatusQuery, useLazyGetConsumerApplicationsV1CreditApplicationsStatusStatusQuery, usePostConsumerApplicationsV1CreditApplicationsApplicationIdIdentityVerificationMutation, useGetConsumerApplicationsV1CreditApplicationsApplicationIdIdentityVerificationQuery, useLazyGetConsumerApplicationsV1CreditApplicationsApplicationIdIdentityVerificationQuery, usePostConsumerApplicationsV1CreditApplicationsApplicationIdApplyMutation, useGetConsumerApplicationsV1LocationsSearchQuery, useLazyGetConsumerApplicationsV1LocationsSearchQuery, useGetConsumerApplicationsV1LocationsSearchFullQuery, useLazyGetConsumerApplicationsV1LocationsSearchFullQuery, useGetConsumerApplicationsV1LocationsLocationIdLenderTermsLenderNameQuery, useLazyGetConsumerApplicationsV1LocationsLocationIdLenderTermsLenderNameQuery, useGetConsumerApplicationsV1BankNameLookupQuery, useLazyGetConsumerApplicationsV1BankNameLookupQuery, usePostConsumerApplicationsV1LinkGenerateMutation, usePostConsumerApplicationsV1LinkFetchMutation, usePostConsumerApplicationsV1LinkOtlGenerateMutation, useGetConsumerApplicationsV1LinkOtlTokenValidateQuery, useLazyGetConsumerApplicationsV1LinkOtlTokenValidateQuery, } = injectedRtkApi;
